import script from "./restaurantInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./restaurantInfoList.vue?vue&type=script&setup=true&lang=js"

import "./restaurantInfoList.vue?vue&type=style&index=0&id=1c7f6dc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7f6dc0"]])

export default __exports__